var _rect, _g, _g2, _path, _g3, _g4, _g5, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 757,
    viewBox: "0 0 1920 757",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 757,
    transform: "matrix(1 0 0 -1 0 757)",
    fill: "url(#paint0_linear_912_114)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1825.69 134.761L1804.21 141.644C1801.95 142.372 1799.52 141.118 1798.79 138.854C1798.06 136.59 1799.32 134.159 1801.58 133.431L1823.06 126.548C1825.32 125.82 1827.75 127.074 1828.48 129.338C1829.21 131.602 1827.96 134.03 1825.69 134.761Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828.36 143.071L1806.88 149.954C1804.62 150.682 1802.19 149.428 1801.46 147.164C1800.73 144.9 1801.98 142.469 1804.25 141.741L1825.72 134.858C1827.99 134.13 1830.42 135.384 1831.15 137.648C1831.88 139.921 1830.62 142.343 1828.36 143.071Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.72 117.411C1785.78 117.449 1785.84 117.499 1785.9 117.538C1787.19 118.478 1795.19 124.556 1800.62 133.855L1823.53 126.294C1822.37 115.589 1825.17 105.94 1825.65 104.42C1825.67 104.353 1825.69 104.28 1825.72 104.212C1825.95 103.481 1826.15 102.733 1826.32 101.984C1827.32 97.542 1827.17 92.7774 1825.64 88.1375C1821.14 74.49 1806.42 67.0687 1792.77 71.5756C1779.12 76.0796 1771.7 90.7978 1776.2 104.454C1777.73 109.094 1780.45 113.012 1783.9 115.986C1784.49 116.492 1785.1 116.964 1785.72 117.411Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.12 149.663C1810.61 153.451 1815.41 155.256 1819.92 153.768C1824.38 152.298 1827.15 148.081 1826.97 143.617L1808.12 149.663Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.73 131.401L1800.93 110.776C1800.26 108.746 1798.07 107.645 1796.04 108.315C1794.01 108.985 1792.91 111.17 1793.58 113.2C1794.25 115.23 1796.44 116.331 1798.47 115.661L1806.64 112.964",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1816.72 128.437L1809.91 107.812C1809.24 105.782 1810.34 103.596 1812.37 102.926C1814.4 102.256 1816.59 103.357 1817.26 105.387C1817.93 107.417 1816.82 109.603 1814.79 110.273L1806.62 112.97",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1833.77 90.9712L1840.67 88.6945",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831.14 82.105L1836.26 76.964",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.33 99.8398L1841.51 100.921",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.7 112.116L1762.8 114.393",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.54 103.424L1759.36 102.344",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.53 119.576L1769.4 124.717",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1001.6 618.027C1001.6 621.234 999.009 623.829 995.802 623.829C992.594 623.829 990 621.234 990 618.027C990 614.82 992.594 612.225 995.802 612.225C999.009 612.225 1001.6 614.82 1001.6 618.027Z",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.86 668.322C1061.07 668.322 1063.67 665.725 1063.67 662.521C1063.67 659.316 1061.07 656.719 1057.86 656.719C1054.66 656.719 1052.06 659.316 1052.06 662.521C1052.06 665.725 1054.66 668.322 1057.86 668.322Z",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.03 650.59C1042.85 650.59 1048.38 645.057 1048.38 638.231C1048.38 631.405 1042.85 625.872 1036.03 625.872C1029.2 625.872 1023.67 631.405 1023.67 638.231C1023.67 645.057 1029.2 650.59 1036.03 650.59Z",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.27 638.231L1052.81 645.177L1051.76 653.951L1042.98 655.003L1036.03 660.468L1029.08 655.003L1020.3 653.951L1019.24 645.177L1013.79 638.231L1019.24 631.275L1020.3 622.501L1029.08 621.449L1036.03 615.984L1042.98 621.449L1051.76 622.501L1052.81 631.275L1058.27 638.231Z",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.06 662.521C1052.06 659.313 1054.66 656.719 1057.86 656.719C1059.59 656.719 1061.14 657.485 1062.21 658.68C1066.62 653.042 1069.26 645.943 1069.26 638.221C1069.26 619.865 1054.38 604.993 1036.04 604.993C1017.68 604.993 1002.81 619.876 1002.81 638.221C1002.81 656.576 1017.69 671.448 1036.04 671.448C1042.48 671.448 1048.51 669.599 1053.6 666.422C1052.64 665.401 1052.06 664.032 1052.06 662.521Z",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.03 593.257C1020.52 593.257 1006.84 601.101 998.765 613.042C1000.46 614.053 1001.6 615.902 1001.6 618.016C1001.6 621.224 999.01 623.818 995.802 623.818C995.016 623.818 994.26 623.655 993.576 623.379C991.952 628.027 991.053 633.021 991.053 638.221C991.053 663.052 1011.19 683.195 1036.03 683.195C1060.86 683.195 1081 663.062 1081 638.221C1081 613.389 1060.87 593.257 1036.03 593.257Z",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1864.56 573.545C1857.86 605.71 1838.67 659.251 1815.55 616.088C1786.65 562.134 1781.92 634.18 1779.58 666.008C1779.77 664.118 1776.08 735.885 1738.61 639.117",
    stroke: "#E541ED",
    strokeOpacity: 0.18,
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.251 172.611L117.951 172.428L117.978 169.171C117.992 167.718 119.181 166.549 120.634 166.556L136.663 166.691C138.116 166.704 139.285 167.894 139.278 169.347L139.251 172.611Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.003 151.622C143.599 149.712 151.451 138.763 149.542 127.167C147.632 115.571 136.683 107.718 125.087 109.628C113.49 111.538 105.638 122.487 107.548 134.083C109.458 145.679 120.406 153.532 132.003 151.622Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.806 151.256L123.284 110.021L121.939 105C107.768 108.615 99.213 123.029 102.828 137.2C106.444 151.371 120.858 159.926 135.029 156.311L133.745 151.277",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.621 119.078C132.738 117.263 137.99 113.762 137.352 111.259C136.713 108.757 130.426 108.2 123.309 110.016C116.192 111.831 110.939 115.332 111.578 117.835C112.216 120.337 118.503 120.894 125.621 119.078Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.826 151.26C140.943 149.444 146.195 145.944 145.557 143.441C144.918 140.939 138.631 140.382 131.514 142.197C124.397 144.013 119.145 147.514 119.783 150.016C120.421 152.519 126.709 153.076 133.826 151.26Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.828 151.257C139.52 149.805 141.779 139.396 138.874 128.008C135.969 116.619 128.999 108.564 123.307 110.017C117.615 111.469 115.355 121.878 118.26 133.266C121.166 144.655 128.135 152.709 133.828 151.257Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93 135.896L149.165 125.381",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.549 157.135V166.562",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.33 172.678H142.537",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M723.52 468.28C723.52 470.027 722.108 471.439 720.361 471.439C718.614 471.439 717.201 470.027 717.201 468.28C717.201 466.533 718.614 465.12 720.361 465.12C722.108 465.12 723.52 466.533 723.52 468.28Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.068 460.319C733.813 460.319 735.227 458.905 735.227 457.16C735.227 455.415 733.813 454 732.068 454C730.323 454 728.908 455.415 728.908 457.16C728.908 458.905 730.323 460.319 732.068 460.319Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.171 471.439C772.171 473.187 770.758 474.599 769.011 474.599C767.264 474.599 765.852 473.187 765.852 471.439C765.852 469.692 767.264 468.28 769.011 468.28C770.758 468.28 772.171 469.692 772.171 471.439Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.505 486.462L718.744 486.323C717.233 486.306 716.025 485.074 716.041 483.571L716.049 482.877C716.066 481.367 717.29 480.159 718.801 480.175L735.562 480.314C737.073 480.33 738.281 481.563 738.265 483.065L738.257 483.759C738.24 485.261 737.007 486.47 735.505 486.462Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.55 505.501V486.454H719.748V505.501L712 533.644C712 537.595 715.209 540.804 719.16 540.804H735.138C739.09 540.804 742.298 537.595 742.298 533.644L734.55 505.501Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.254 518.197C716.254 518.197 720.663 515.372 727.145 518.76C733.628 522.157 737.62 516.678 737.62 516.678",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.511 486.462L756.749 486.323C755.239 486.306 754.031 485.074 754.047 483.571L754.055 482.877C754.072 481.367 755.304 480.159 756.807 480.175L773.568 480.314C775.079 480.33 776.287 481.563 776.271 483.065L776.262 483.759C776.254 485.261 775.021 486.47 773.511 486.462Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.762 533.603C757.762 537.693 761.077 541 765.159 541C769.249 541 772.556 537.685 772.556 533.603V486.454H757.754V533.603H757.762Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.762 533.603C757.762 537.693 761.077 541 765.159 541C769.249 541 772.556 537.685 772.556 533.603V486.454H757.754V533.603H757.762Z",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.762 517.168C759.656 516.939 762.277 517.144 765.371 518.76C768.335 520.311 770.784 520.009 772.564 519.225",
    stroke: "#5956E9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M850.212 117.476L837.68 114.536L825.558 166.197L838.091 169.137L850.212 117.476Z",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.756 123.677L842.49 122.207",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.948 135.646L839.682 134.176",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.141 147.615L836.875 146.145",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.333 159.584L834.066 158.113",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.828 127.635L844.695 126.9",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.889 131.64L843.756 130.905",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.014 139.628L841.881 138.893",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.075 143.633L840.941 142.898",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.201 151.62L839.068 150.885",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.26 155.626L838.127 154.891",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.799 129.979L818.043 129.098",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.991 141.948L815.234 141.066",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.182 153.916L812.426 153.035",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.678 121.968L821.803 121.528",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.738 125.974L820.863 125.534",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.863 133.961L818.988 133.521",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.924 137.966L818.049 137.526",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.051 145.953L816.176 145.513",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.195 158.118L813.32 157.678",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.11 149.959L815.234 149.519",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.238 156.977L826.061 111.809L813.938 163.476L786.238 156.977Z",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.599 152.395L811.492 140.045L808.177 154.173L800.599 152.395Z",
    stroke: "#E541ED",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.024 643.205H112.654C112.217 643.205 111.859 642.848 111.859 642.411V621.499C111.859 621.062 112.217 620.705 112.654 620.705H120.024C120.461 620.705 120.818 621.062 120.818 621.499V642.411C120.818 642.848 120.461 643.205 120.024 643.205Z",
    stroke: "#5956E9",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.122 643.206H127.751C127.314 643.206 126.957 642.848 126.957 642.411V614.002C126.957 613.565 127.314 613.208 127.751 613.208H135.122C135.558 613.208 135.916 613.565 135.916 614.002V642.411C135.916 642.848 135.558 643.206 135.122 643.206Z",
    stroke: "#5956E9",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.219 643.206H142.849C142.412 643.206 142.055 642.848 142.055 642.411V606.497C142.055 606.06 142.412 605.703 142.849 605.703H150.219C150.656 605.703 151.013 606.06 151.013 606.497V642.411C151.013 642.848 150.664 643.206 150.219 643.206Z",
    stroke: "#5956E9",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9688 589V654.022",
    stroke: "#5956E9",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164 643.205H86",
    stroke: "#5956E9",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_912_114",
    x1: 960,
    y1: 0,
    x2: 960,
    y2: 757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273661,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747647,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE6FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBg);
export default __webpack_public_path__ + "static/media/main_bg.64dda38f294a06b0f56ed7fdd40c7697.svg";
export { ForwardRef as ReactComponent };